import { HttpError } from "@bps/http-client";

import { AlertError } from "./Alert.types.ts";

export const getErrorMessage = (error: AlertError | undefined) => {
  if (typeof error === "string") return error;

  if (error instanceof HttpError) {
    if (error.detail) return String(error.detail);

    if (error.message) return String(error.message);

    if (error.httpStatusCode === 412)
      return "Data is out of date.  Please refresh the browser.";

    if (error.httpStatusCode === 403)
      return "You do not have the necessary permissions to make this change.";
  }

  return "An error request occurred.";
};

export const getStackTrace = (error: AlertError) => {
  if (error instanceof Error) return error;
  return undefined;
};
